import { Checkbox, Form, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { positionToOrgMapping } from "utils";
import { getOrgStaffProfileOrgField } from "utils";
import { getOrgDashboardIdField } from "utils";
import {
  addNewGuarantor,
  getStaffsWithParams,
} from "../store/clients";

const Option = Select.Option;

const RegisterGuarantor = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [cos, setCos] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state) => state.users);

  useEffect(() => {
    setLoading(true)
    const orgType = getOrgStaffProfileOrgField(user?.position);
    const orgIdField = getOrgDashboardIdField(user?.position);
    const orgFieldId =
      user?.position === "CO" ? user?.id : user?.[orgType]?.id;
      
    let queryString = "";
    queryString = queryString.concat(`${orgIdField}=${orgFieldId}`);

    if (user?.position === "CO") {
      setCos([user]);
    } else {
      dispatch(getStaffsWithParams(queryString)).then((result) => {
        setCos(result);
      });
    }
    setLoading(false)
  }, []);

  const handleSubmit = async (values) => {
    setLoading(true)
    dispatch(addNewGuarantor(values));
    form.resetFields();
    setLoading(false)
  };

  return (
    <>
      <Container fluid>
        <h3 className="page-title mb-4">Register Guarantor</h3>
        <Form form={form} onFinish={handleSubmit}>
          <Row>
            <Col className="" md="3">
              <Form.Item
                name="Title"
                label="title"
                rules={[
                  {
                    required: true,
                    message: "Please provide title",
                  },
                ]}
              >
                <Input
                  placeholder="Title"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="4">
              <Form.Item
                name="surname"
                label="Surname"
                rules={[
                  {
                    required: true,
                    message: "Please provide surname",
                  },
                ]}
              >
                <Input
                  placeholder="Surname"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="5">
              <Form.Item
                name="firstname"
                label="Firstname"
                rules={[
                  {
                    required: true,
                    message: "Please provide a first name",
                  },
                ]}
              >
                <Input
                  placeholder="First Name"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col className="" md="6">
              <Form.Item
                name="house_address"
                label="House Address"
                rules={[
                  {
                    required: true,
                    message: "Please provide house address",
                  },
                ]}
              >
                <Input
                  placeholder="House Adress"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item
                name="office_address"
                label="Office/Business Address"
                rules={[
                  {
                    required: true,
                    message: "Please provide office address",
                  },
                ]}
              >
                <Input
                  placeholder="Office/Business Address"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col className="" md="6">
              <Form.Item
                name="phone_number1"
                label="Phone Number 1"
                rules={[
                  {
                    required: true,
                    message: "Please provide phone number 1",
                  },
                ]}
              >
                <Input
                  placeholder="Phone Number 1"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item label="Phone Number 2" name="phone_number2">
                <Input
                  placeholder="Phone Number 2"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col className="" md="6">
              <Form.Item
                name="marital_status"
                label="Marital Status"
                rules={[
                  {
                    required: true,
                    message: "Please provide marital status",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select marital Status"
                  optionFilterProp="children"
                  className="custom-input"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  allowClear
                >
                  <Option value="single" key="single">
                    Single
                  </Option>
                  <Option value="married" key="married">
                    Married
                  </Option>
                </Select>
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item
                name="number_of_children"
                label="Number of children"
                rules={[
                  {
                    required: true,
                    message: "Please provide number of children",
                  },
                ]}
              >
                <Input
                  placeholder="Number of children"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col className="" md="6">
              <Form.Item
                name="nin"
                label="NIN"
                className="mb-3"
                rules={[
                  {
                    required: true,
                    message: "Please provide a valid NIN",
                  },
                  {
                    min: 11,
                    max: 11,
                    message: "Please provide a valid NIN",
                  },
                ]}
              >
                <Input
                  placeholder="Your NIN number"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item
                name="co_id"
                label="Credit Officer"
                rules={[
                  {
                    required: true,
                    message: "Please select a credit officer",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select credit officer"
                  optionFilterProp="children"
                  className="custom-input"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  allowClear
                >
                  {cos?.map((inst) => (
                    <Option value={inst.id} key={inst.id}>
                      {inst.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Button variant="primary" className="px-5" type="submit" disabled={loading}>
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </>
  );
};

export { RegisterGuarantor };
